export default "__VITE_ASSET__BH9vJ1E2__"